/**
 * src/functions/tdd_fetch_functions.ts
 *
 * NOTE (2026-07-07): the retired API-subdomain backend is dead — its
 * vhost was removed. Every helper that fetched it (fetchDirectoryList,
 * fetchValidPathItems, fetchPdfViewerInfo, fetchValidPdfs, fetchTweetData,
 * renderSources, …) has been deleted; the originals are preserved in
 * old/seo-retire-20260707/ (tdd_fetch_functions.ts.bak-20260707b next to this
 * file). What replaced them:
 *   - navbar:       generated at build time (src/generated/navbarPaths)
 *   - pdf metadata: static, same-origin /pdfs/<baseId>/info.json
 *                   (fetchPdfInfo below — degrades to null when absent)
 */
import { buildNavFromPaths } from '@utils/pathsToNav';
import { NAVBAR_FILE_LIST } from './../generated/navbarPaths';

export async function fetchNavbarProps() {
  try {
    return buildNavFromPaths(Array.from(NAVBAR_FILE_LIST));
  } catch (e) {
    console.error('fetchNavbarProps fallback error', e);
    return [];
  }
}

/**
 * Fetch a PDF's static metadata (same-origin /pdfs/<baseId>/info.json, built
 * by the offline pdf pipeline: {combined_keywords, document_summary, …}).
 * The file may legitimately be absent for some documents — returns null
 * instead of throwing so viewers can degrade gracefully.
 */
export async function fetchPdfInfo(
  pdfInfoUrl: string,
  { signal }: { signal?: AbortSignal } = {}
): Promise<any | null> {
  try {
    const res = await fetch(pdfInfoUrl, { signal });
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    if (e instanceof Error && e.name === 'AbortError') throw e;
    return null;
  }
}
